<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="contract-content">
      <div class="contract content-wrapper">
        <el-row>
          <el-col :span="12">
            <div class="page-header">
              <el-button type="text" @click="goToSpecialOfferListPage">
                &ll; {{ $t('back') }}
              </el-button>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button type="primary" @click="onShowPreviewButtonClick()">{{ $t('previewSpecialOffer') }}</el-button>
          </el-col>
        </el-row>
        <div class="contract-container">
          <special-offer-menu-component
            @onClickSpecialOfferMenu="onShowSpecialOfferContainer">
          </special-offer-menu-component>
          <div class="tab-contract-container">
            <div v-show="isShowContainer.general">
              <tab-general-component
                v-model="specialOfferDetail"
                :hotel="hotel"
                :sale-person-list="salePersonList"
                :ref-code-format="companyData.specialOffer.refCodeFormat"
                :market-list="marketList">
              </tab-general-component>
            </div>
            <div v-show="isShowContainer.agent">
              <tab-agent-component
                v-model="specialOfferDetail"
                :agent-list="agentList"
                :market-list="marketList"
                :agent-type-list="agentTypeList"
              ></tab-agent-component>
            </div>
            <div v-show="isShowContainer.promotion">
              <tab-promotion-component
                v-model="specialOfferDetail"
                :promotion-list="promotionList"
                :room-type-list="roomTypeList">
              </tab-promotion-component>
            </div>
          </div>
        </div>
      </div>
      <div class="special-offer">
        <el-form ref="form" label-width="0" style="margin-top: -30px">
          <el-form-item>
            <el-button v-if="specialOfferDetail.status === SPECIAL_OFFER_STATUS.DRAFT"
                       type="info"
                       style="width: 100%;"
                       @click="onSaveDraftButtonClick">
              {{ $t('saveDraft') }}
            </el-button>
            <el-button v-if="specialOfferDetail.status === SPECIAL_OFFER_STATUS.PUBLISHED"
                       type="primary"
                       style="width: 100%;"
                       @click="onSaveButtonClick">
              {{ $t('saveSpecialOffer') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <preview-special-offer-component
      :visible="isShowPreview"
      :special-offer-detail="specialOfferDetail"
      :hotel="hotel"
      :room-type-list="roomTypeList"
      @onClose="isShowPreview = false"
      @onSaveDraft="onPreviewSaveDraft"
      @onSavePublish="onPreviewSavePublish"
    ></preview-special-offer-component>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/ManageSpecialOffer/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import SpecialOfferMenuComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/SpecialOfferMenuComponent'
import PreviewSpecialOfferComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/PreviewSpecialOfferComponent'
import TabGeneralComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/TabGeneralComponent'
import TabPromotionComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/TabPromotionComponent'
import TabAgentComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/TabAgentComponent'
import { STATUS, SPECIAL_OFFER_STATUS, SPECIAL_OFFER_REF_CODE_TYPE, VUEX_EVENT } from '@/configs/constant'
import { genPreviewRefCode } from '@/domains/special-offer-domain'
import { get } from 'lodash'
import { mapState } from 'vuex'

import AgentService from '@/services/agent-service'
import SpecialOfferApi from '@/api/special-offer-api'

export default {
  name: 'SpecialOfferEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: {
    ContentContainer,
    SpecialOfferMenuComponent,
    PreviewSpecialOfferComponent,
    TabGeneralComponent,
    TabPromotionComponent,
    TabAgentComponent
  },
  i18n: { messages: i18nMessages },
  props: {
    specialOfferId: {
      type: String,
      default: ''
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    promotionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      SPECIAL_OFFER_STATUS,
      isLoading: false,
      isShowPreview: false,
      isShowContainer: {
        general: true,
        agent: false,
        rateCode: false,
        allotment: false,
        promotion: false,
        supplement: false,
        transfer: false,
        termsOfPayment: false
      },
      specialOfferDetail: {
        autoRefCode: STATUS.DISABLE,
        status: SPECIAL_OFFER_STATUS.DRAFT,
        refCode: '',
        refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
        hotel: {
          id: '',
          information: {
            code: '',
            name: ''
          },
          salePerson: {
            id: '',
            title: '',
            firstName: '',
            lastName: '',
            position: '',
            email: '',
            updatedAt: ''
          }
        },
        promotion: {
          id: '',
          code: '',
          detail: '',
          minNight: 0,
          maxNight: 0,
          isEnable: 0,
          updatedAt: 0,
          bookingPeriod: {
            startDate: '',
            endDate: ''
          },
          periodOfStayList: [],
          isEnableAllotment: 0,
          roomTypeList: []
        },
        agentList: [],
        general: {
          startDate: '',
          endDate: '',
          issueDate: '',
          internalNote: '',
          footerMessage: '',
          bodyMessage: ''
        }
      },
      companyData: {
        code: '',
        companyType: 0,
        contract: {
          refCodeFormat: ''
        },
        specialOffer: {
          refCodeFormat: ''
        },
        currency: 'THB'
      },
      roomTypeList: [],
      agentList: [],
      marketList: [],
      salePersonList: [],
      agentTypeList: []
    }
  },
  computed: {
    ...mapState({
      specialOfferListCurrentPage: state => state.specialOffer.specialOfferListCurrentPage,
      specialOfferPageListStore: state => state.specialOffer.specialOfferPageListStore
    })
  },
  created: async function () {
    this.isLoading = true

    if (this.specialOfferId === undefined || this.specialOfferId === '') {
      return this.$router.push({
        name: 'SpecialOfferList'
      })
    }

    try {
      const result = await Promise.all([
        AgentService.getAgentList(),
        SpecialOfferApi.detail(this.specialOfferId)
      ])

      this.agentList = result[0]
      const specialOfferResult = result[1]

      this.roomTypeList = specialOfferResult.roomTypeList
      this.salePersonList = specialOfferResult.salePersonList
      this.marketList = specialOfferResult.marketList
      this.agentTypeList = specialOfferResult.agentTypeList
      this.companyData = Object.assign(this.companyData, specialOfferResult.companyData)

      this._initSpecialOfferDetail(specialOfferResult.specialOfferDetail)
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  methods: {
    _initSpecialOfferDetail: function (specialOfferDetail) {
      const specialOfferPromotion = get(specialOfferDetail, 'promotion', {})
      const specialOfferRoomTypeList = get(specialOfferPromotion, 'roomTypeList', [])
      const appliedRoomTypeNameList = specialOfferRoomTypeList.map(specialOfferRoomType => {
        const roomTypeSourceData = this.roomTypeList.find(roomTypeSource => roomTypeSource.id === specialOfferRoomType.id)
        const roomTypeSourceName = get(roomTypeSourceData, 'name', '')
        const specialOfferRoomTypeName = get(specialOfferRoomType, 'name', '')

        const newRoomTypeName = {
          name: (!specialOfferRoomTypeName) ? roomTypeSourceName : specialOfferRoomTypeName
        }
        const newRoomType = Object.assign({}, specialOfferRoomType, newRoomTypeName)

        return newRoomType
      })

      const newRoomTypeList = {
        roomTypeList: appliedRoomTypeNameList
      }
      const newPromotion = Object.assign({}, specialOfferPromotion, newRoomTypeList)
      const newSpecialOfferPromotion = {
        promotion: newPromotion
      }
      this.specialOfferDetail = Object.assign({}, specialOfferDetail, newSpecialOfferPromotion)
    },
    goToSpecialOfferListPage: function () {
      return this.$router.push({
        name: 'SpecialOfferList'
      })
    },
    onShowSpecialOfferContainer: function (isShowContainer) {
      this.isShowContainer = isShowContainer
    },
    onShowPreviewButtonClick: function () {
      if (Boolean(this.specialOfferDetail.autoRefCode) === true) {
        let refCodeFormat = get(this.companyData, 'specialOffer.refCodeFormat', '').toUpperCase()
        this.specialOfferDetail.refCode = genPreviewRefCode(this.specialOfferDetail, refCodeFormat, this.marketList)
      }

      this.isShowPreview = true
    },
    onSaveDraftButtonClick: async function () {
      await this._saveSpecialOffer()
    },
    onSaveButtonClick: async function () {
      await this._saveSpecialOffer()
    },
    onPreviewSaveDraft: async function () {
      this.isShowPreview = false
      await this._saveSpecialOffer()
    },
    onPreviewSavePublish: async function () {
      this.isShowPreview = false
      this.specialOfferDetail.status = SPECIAL_OFFER_STATUS.PUBLISHED
      await this._saveSpecialOffer()
    },
    _saveSpecialOffer: async function () {
      try {
        this.startLoading()

        if (Boolean(this.specialOfferDetail.autoRefCode) === true) {
          let refCodeFormat = get(this.companyData, 'specialOffer.refCodeFormat', '').toUpperCase()
          this.specialOfferDetail.refCode = genPreviewRefCode(this.specialOfferDetail, refCodeFormat, this.marketList)
        }

        await SpecialOfferApi.save(this.specialOfferDetail)
        this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.UPDATE_SPECIAL_OFFER_PAGE_LIST_STORE, {
          pageNumber: this.specialOfferListCurrentPage,
          specialOfferDetail: this.specialOfferDetail
        })

        this.$router.push({
          name: 'SpecialOfferList'
        })

        const title = this.$t('updateSpecialOfferSuccessTitle')
        const message = this.$t('updateSpecialOfferSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}
</script>

<style scoped>
  .page-header > small {
    font-size: 14px;
    color: #666;
  }
  .page-header > .el-button {
    font-size: 23px;
  }
  .page-header > .el-button > span > small {
    font-size: 14px;
    color: #666;
  }
  .table-contract-container {
    margin: 0 30px;
    box-shadow: #d4d4d4 0 0 5px;
    border: 1px solid #dddddd;
    border-radius: 5px;
  }
  .contract-container {
    box-shadow: #d4d4d4 0 0 5px;
    padding: 30px;
    border: 1px solid #dddddd;
    border-radius: 5px;
    position: relative;
  }
</style>
